<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--ballot">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main>
      <app-progress-bar [routeName]="routeName"></app-progress-bar>
      @if(ballotService.ballotType === 'POLL') {
        <h1 class="vtz-h1" id="main-title" i18n>Poll</h1>
      } @else {
        <h1 class="vtz-h1" id="main-title" i18n>Ballot</h1>
      }
      @if (!thisContest?.isRCV) {
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
          Instructions: Make your selection(s) for each of the questions below. Once you are finished, review your
          selections before you submit.
        </p>
      }
      @if (thisContest?.isRCV) {
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
          Select the choice(s) below to begin ranking. Your ranked choices will appear in the Ranked section, and can be re-ordered.
        </p>
      }

      <div class="vtz-questions__list">
        <!-------------------------------------------------------   R C V  ------------------------------------------------------->
        @if (thisContest?.isRCV) {
        <div class="vtz-questions__list-item vtz-questions__list-item_rcv">
          <div class="vtz-sticky">
            <!-- VSP-1088: Previously, this caused some flickering on some browsers in the past. -->
            @if(ballotService.ballotType === 'POLL') {
              <h2 class="vtz-contest-counter" i18n>
                Question {{currentContest + 1}} of {{(ballot?.contest_list?.length ?? -1)}}
              </h2>
            } @else {
              <h2 class="vtz-contest-counter" i18n>
                Contest {{currentContest + 1}} of {{(ballot?.contest_list?.length ?? -1)}}
              </h2>
            }
            <h2 class="vtz-contest-description"
              [ngClass]="{'vtz-contest-description-justify': contestDescriptionJustify }">
              {{contest_name}} <br>
              {{ rankDescription1}}
            </h2>
          </div>
          <!--------------------------------------------------------------------------->
          <div class="tooltip-container" style="background-color: #f4f6fa;">
            <h3 class="vtz-text vtz-text--small vtz-text--wide vtz-text--bold" style="color: #253E60;">
              <strong i18n >RANKED:</strong>
            </h3>
            <div   >
              @if (questionMaxSelect) {
                <span class="vtz-questions__counter-text" i18n>
                  <strong>{{rankedSelectedLenght}}</strong> of <strong>{{questionMaxSelect}}</strong>
                  Ranked
                </span>
              }@else {
                <span class="vtz-questions__counter-text" i18n>
                  <strong>{{rankedSelectedLenght}}</strong>
                  Ranked
                </span>
              }


            </div>
            <button mat-raised-button
              matTooltip="{{rankedHelp}}"
              matTooltipClass="white-space-pre-line"
              [matTooltipPosition]="'left'"
              aria-label="Tooltip">
              Help
            </button>
          </div>
          <div>
            @if(thisContest?.rankedStatements?.length === 0) {
            <p>No ranked options yet.</p>
            }
          </div>
          @for (ranked of thisContest?.rankedStatements; track ranked; let i = $index) {
          <app-ranked-choice [ranked]="ranked" [index]="i" (moveUp)="moveUp($event)"
            (moveDown)="moveDown($event)"></app-ranked-choice>
          }
          <div style="display: flex;width: 100%;">
            @if(maxRankedReached){
              <p  style="text-align: center;color: rgb(5, 145, 70);width: 100%;">Maximum number of selections reached</p>
            }            
          </div>

          <div>
            <div class="tooltip-container" style="margin-top: 8px;">
              <h3 class="vtz-text vtz-text--small vtz-text--wide vtz-text--bold" style="color: #253E60;">
                <strong i18n>UNRANKED:</strong>
              </h3>
              <button mat-raised-button matTooltip="To 
              rank a candidate, 
              press the 'Rank' button."
                matTooltipClass="white-space-pre-line"
                [matTooltipPosition]="'left'"
                aria-label="tooltip">
                Help
              </button>
            </div>
          </div>
          <div role="list">
            @for (unranked of thisContest?.unrankedStatements; track unranked; let i = $index) {
            <app-unranked-choice [unranked]="unranked" [index]="i" (rank)="rank($event)"></app-unranked-choice>
            }
          </div>
        </div>
        }
        <!---------------------------------------------N O N   R C V  ------------------------------------------------------->
        @if(!thisContest?.isRCV){
        <div class="vtz-questions__list-item">
          @if(ballotService.ballotType === 'POLL') {
            <h2 class="vtz-contest-counter" i18n>
              Question {{currentContest + 1}} of {{(ballot?.contest_list?.length ?? -1)}}
            </h2>
          } @else {
            <h2 class="vtz-contest-counter" i18n>
              Contest {{currentContest + 1}} of {{(ballot?.contest_list?.length ?? -1)}}
            </h2>
          }
          <h2 class="vtz-contest-description"
            [ngClass]="{'vtz-contest-description-justify': contestDescriptionJustify }">
            {{contest_name}}
          </h2>
          <div class="vtz-description1-container">
            <legend class="vtz-text vtz-text--small vtz-text--wide vtz-text--bold">
              @if (!hasAcclaimedChoice) {
              <div id="choice-counter" class="vtz-questions__counter"
                [ngClass]="{'vtz-questions__counter--error': maxSelectionError || minSelectionError,
                            'vtz-questions__counter--warning': isUndervote}">
                <span class="vtz-questions__counter-text" i18n >
                  <strong>{{ selectedChoices?.length }}</strong> of <strong>{{ thisContest?.maxSelect }}</strong>
                  Selected
                </span>
                <!-- For Screen Reader use Only -->
                <span class="sr-only" aria-live="assertive">
                  {{ selectedChoices?.length }} of {{ thisContest?.maxSelect }} Selected
                </span>
              </div>
              }
              @if (description1HasHtml) {
              <div [innerHtml]="description1"></div>
              }
              @if (!description1HasHtml) {
              <span>{{description1}}</span>
              }
              @if (description2HasHtml) {
              <div [innerHtml]="description2"></div>
              }
              @if (!description2HasHtml) {
              <span>{{description2}}</span>
              }
            </legend>
          </div>
          <!--------------------------Right Oval------------------------------------>
          <div role="group" attr.aria-label="{{ariaLabelForContest}}">
            @for (choice of thisContest?.choices; track choice; let i = $index) {
            @if(!choice.isWriteIn){
            <app-oval-choice [ovalOnRight]="ovalOnRight || false" [choice]="choice"
              (selectedChoice)="selectedChoiceEvent($event)"></app-oval-choice>
            }
            @if (choice.isWriteIn) {
            <app-write-in-choice [ovalOnRight]="ovalOnRight || false" [choice]="choice"
              (selectedChoice)="selectedChoiceEvent($event)"
              [descriptions]="jsonWriteInDescriptions"></app-write-in-choice>
            }
            }
            <div aria-live="assertive">
              @if (maxSelectionError) {
                <span class="vtz-form__error vtz-form__error--ballot" i18n="Invalid ballot selection">
                  <img src="/assets/images/warning.svg" alt="alert" width="30" height="30">
                  The maximum number of selections for "{{contest_name}}" is {{maxSelect!}}.
                  Please deselect at least {(selectedChoices!.length! - maxSelect! ), plural, =1
                  {{{selectedChoices!.length! - maxSelect!}} choice}
                  other {{{selectedChoices!.length! - maxSelect!}} choices}} in order to continue.
                </span>
              }
              @if (minSelectionError) {
                <span class="vtz-form__error vtz-form__error--ballot" i18n="Invalid ballot selection">
                  <img src="/assets/images/warning.svg" alt="alert" width="30" height="30">
                  The minimum number of selections for "{{contest_name}}" is {{minSelect!}}.
                  Please select at least { minSelect! , plural, =1
                  {{{minSelect!}} choice}
                  other {{{minSelect!}} choices}} in order to continue.
                </span>
              }
            </div>
          </div>

        </div>
        }
      </div>
   <!---------------------------------------------------PREVIOUS------------------------------------------------------------->
   <div class="vtz-actions vtz-actions--multi-screen-ballot">
    <div class="vtz-actions_col">
      @if (currentContest !== 0) {
        <button id="go-to-previous" class="button-primary" (click)="previous()" i18n="Button label">
          PREVIOUS
        </button>
      } @else {
          @if(about.hasDashboard) {
            <button id="back-to-dashboard0" class="button-primary" (click)="back()" i18n="Button label">
              BACK
            </button>
          } 
      }
    </div>
    <!-------------------------------------------------- clear contest------------------------------------------------------------------->
    <div class="vtz-actions_col">
      <button [disabled]="hasAcclaimedChoice" class="vtz-link--no-underline" (click)="clearContest()" i18n  id="clear-contest">clear
        selection</button>
    </div>
    <!-------------------------------------------------- NEXT------------------------------------------------------------------->
    <div class="vtz-actions_col">
      <button [disabled]="maxSelectionError || minSelectionError || isWriteinInvalid" id="go-to-next" class="button-primary" (click)="next()"  
        i18n="Button label">
        NEXT
      </button>
    </div>
    <!----------------------------------------------------------------------------------------------------------------------------->
  </div>
  @if(about.hasDashboard && (currentContest !== 0)) {
    <div class="back-button-container">
      <button id="back-to-dashboard" class="button-primary" (click)="back()" i18n="Button label">
        BACK
      </button>
    </div>
  }
</main>
</div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>